import React, { Suspense } from 'react'
import Header from '../Header/Header'
import { LoadingPage } from '../LoadingPage/LoadingPage'
import Lheader from '../Landingpageheader/Lheader'
// import Footer from '../Footer/Footer'

const Layout = ({ children }) => {
  return (
    <Suspense fallback={<LoadingPage />}>

      <div className='layoutmian'>

        <Lheader />
        {children}
        {/* <Footer/> */}
      </div>
    </Suspense>
  )
}

export default Layout